import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';

import { cn } from '~/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';

function Avatar({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Root>) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn(
        'relative flex size-8 shrink-0 overflow-hidden rounded-full',
        className,
      )}
      {...props}
    />
  );
}

function AvatarImage({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Image>) {
  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn('aspect-square size-full', className)}
      {...props}
    />
  );
}

const avatarFallbackVariants = cva(
  'bg-muted flex size-full items-center justify-center rounded-full',
  {
    variants: {
      variant: {
        default: '',
        selected: 'text-secondary-foreground',
      },
    },
  },
);

type BaseAvatarFallbackProps = React.ComponentPropsWithoutRef<
  typeof AvatarPrimitive.Fallback
>;

export interface AvatarFallbackProps
  extends VariantProps<typeof avatarFallbackVariants>,
    BaseAvatarFallbackProps {}

function AvatarFallback({ variant, className, ...props }: AvatarFallbackProps) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn(avatarFallbackVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Avatar, AvatarImage, AvatarFallback };
